export enum EntityType {
  Order = 'ORDER',
  Catalog = 'CATALOG',
}

export enum AccessConfig {
  Public = 'Public',
  Private = 'Private',
}

export enum ShareChannelEnum {
  EMAIL = 'EMAIL',
  WHATSAPP = 'WHATSAPP',
  COPY = 'COPY',
}
